import React from 'react';
import { BookOpenIcon, ListChecksIcon, UsersIcon, ArrowDownIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const steps = [{
  icon: BookOpenIcon,
  title: 'Open',
  body: 'Your professional library'
}, {
  icon: ListChecksIcon,
  title: 'Choose',
  body: 'The class you want to teach'
}, {
  icon: UsersIcon,
  title: 'Teach',
  body: 'With a complete, clear plan'
}];
export function ProblemSolutionSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="problem-heading" data-id="element-112" data-mp="399r4flxsy90c">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-113" data-mp="3e79g3k37f2c1">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-14" data-id="element-114" data-mp="30785hcx50gjd">
          <div className="flex flex-col items-center text-center lg:justify-center" data-id="element-115" data-mp="349uznkha6djq">
            <SectionLabel data-id="element-116" data-mp="34bpovazl4rtm">The reality</SectionLabel>
            <h2 id="problem-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-117" data-mp="1os1k7xpbenxv">
              Does this sound familiar?
            </h2>
            <p className="mt-4 max-w-md text-[0.98rem] leading-relaxed text-muted sm:text-lg" data-id="element-118" data-mp="yl6ft6gmamng">
              Tomorrow you have another class to teach. So tonight you open old notes, search for
              ideas, rebuild sequences and try not to repeat last week’s class.
            </p>
            <p className="mt-4 max-w-md border-t border-clay/50 pt-4 text-[0.98rem] leading-relaxed text-ink sm:text-lg" data-id="element-119" data-mp="13gvivjruiloi">
              The problem isn’t that you don’t know yoga. The problem is having to start from
              scratch every time.
            </p>
          </div>

          <div className="rounded-3xl border border-sandDark bg-cream p-5 text-center sm:p-7" data-id="element-120" data-mp="1r6g4ybjapz20">
            <h3 className="font-serif text-[1.25rem] font-semibold uppercase leading-tight text-forest sm:text-2xl" data-id="element-121" data-mp="1m9zcj552cyj4">
              What if your next class was already planned?
            </h3>

            <ol className="mt-5 space-y-1" data-id="element-122" data-mp="1vanta7ludczp">
              {steps.map(({
              icon: Icon,
              title,
              body
            }, index) => <li key={title} data-id="element-123" data-mp="sxhw9k1eeq25" data-mpi={index}>
                  <div className="flex items-center justify-center gap-3 rounded-2xl border border-sandDark/80 bg-ivory px-4 py-3 text-center" data-id="element-124" data-mp="xv17eb2sumpv">
                    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-cream" data-id="element-125" data-mp="11vk007cinwt4">
                      <Icon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-126" data-mp="16o4qp004ltsf" />
                    </span>
                    <span className="min-w-0" data-id="element-127" data-mp="1blwi7swuzdw3">
                      <span className="block font-serif text-sm font-semibold uppercase tracking-label text-ink" data-id="element-128" data-mp="1gl96mi3dot0s">
                        {title}
                      </span>
                      <span className="block text-[0.82rem] leading-snug text-muted" data-id="element-129" data-mp="1liriag8s5mch">{body}</span>
                    </span>
                  </div>
                  {index < steps.length - 1 ? <div className="flex justify-center py-1" aria-hidden="true" data-id="element-130" data-mp="3nebmkmskjekx">
                      <ArrowDownIcon className="h-3.5 w-3.5 text-sageSoft" data-id="element-131" data-mp="3rdu5jd0txfl4" />
                    </div> : null}
                </li>)}
            </ol>

            <div className="mt-5 grid grid-cols-[1fr_auto_1fr] items-center gap-3 rounded-2xl bg-forest px-4 py-3 text-center" data-id="element-132" data-mp="3f2jf7kk7n1zp">
              <p className="font-serif text-[0.78rem] italic leading-tight text-ivory/70" data-id="element-133" data-mp="3a25howg8jafx">
                “What am I teaching tomorrow?”
              </p>
              <span className="text-goldSoft" aria-hidden="true" data-id="element-134" data-mp="6mgfq2394jmg">
                →
              </span>
              <p className="font-serif text-[0.82rem] font-semibold leading-tight text-ivory" data-id="element-135" data-mp="1phlljjl8co9">
                “Which class do I want to teach?”
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}